











/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import FeeRuleAddEdit from './components/add-edit.vue';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import { TEMPORARY_PARKING_CHARGING_RULE } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { FeeRuleAddEdit }
})
export default class TempRuleCreate extends Mixins(GoBackWithCloseTabMixin) {
  saveOk() {
    // @ts-ignore
    this.id = '';
    // @ts-ignore
    this.billingWay = '';
    // @ts-ignore
    this.addOrEditWrapStatus = '';
    // @ts-ignore
    this.isVisibleAddOrEditWrap = false;
  }
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: TEMPORARY_PARKING_CHARGING_RULE
    });
  }
}
